import React from "react"
import { iProgressCardDataItem } from "../ProgressPanel/ProgressCard"
import { iGDM_CALC_STRUCTURE } from "../Structure"
import SiteContainer from "../../../../utils/SiteContainer"
import gdmPredictedRisk_v2020 from "../getPredictedRisk_v2020"
import IncompleteData from "./IncompleteData"
//import ResultGaugeCard from "./ResultGuageCard"
import IsFormFilled from "../ProgressPanel/IsFormFilled"
import InsightsCard_v2020 from "./InsightsCards/v2020"
//import TruthTableCard from "./TruthTableCard"
import { FaProjectDiagram } from "react-icons/fa"
import CalculatorParameters_v2020_B from "../CalculatorParameters_v2020_B"
//import RiskDotCard from "./RiskDotCard"
//import WeightGain from "./WeightGainCard"

interface iResultsPanel {
  data: {
    [id: string]: iProgressCardDataItem
  }
  calculatorStructure: iGDM_CALC_STRUCTURE
}

interface iResultsPanelView {
  gdmRisk_v2020_B: number
  progressCardData: {
    [id: string]: iProgressCardDataItem
  }
}

/*const ResultModelHeading: React.FC<{ title: string }> = ({ title }) => (
  <div className="flex items-center justify-center md:justify-start">
    <p className="leading-none flex items-center text-xl bg-site-pink text-white  rounded-full px-6 py-3">
      <span className="block mr-3">
        <FaProjectDiagram />
      </span>
      <span>{title}</span>
    </p>
  </div>
)*/

const ResultsPanelView: React.FC<iResultsPanelView> = ({
  gdmRisk_v2020_B,
  progressCardData,
}) => {
  //const height = progressCardData.height.value
  //const weight = progressCardData.pre_pregnancy_weight.value
  //const valueOfBMI = (weight * 10000) / height / height
  return (
    <SiteContainer>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/*
        <div className="col-span-1 md:col-span-2 lg:col-span-3">
          <ResultModelHeading title="Model v2020 (Fixed effects)" />
        </div>
        */}
        {/*<ResultGaugeCard heading="Prediction" value={gdmRisk_v2020_B} />*/}
        {/*<RiskDotCard value={gdmRisk_v2020_B} />*/}
        <InsightsCard_v2020
          heading="Our predicted risk"
          value={gdmRisk_v2020_B}
          cutoff={15.0}
        />
        {/*
          <div>
            <TruthTableCard
              truePositive={62.71}
              falsePositive={28.02}
              trueNegative={71.98}
              falseNegative={37.29}
              statement={"For prediction percentage >= 15%"}
              value={gdmRisk_v2020_B}
              cutoff={0}
              heading="Confusion matrix"
            />
          </div>
          <div className="col-span-1 md:col-span-2">
            <WeightGain BMI={valueOfBMI} weight={weight}/>
          </div>
          */}
      </div>
      <div className="py-8"/>
    </SiteContainer>
  )
}

const ResultsPanel: React.FC<iResultsPanel> = ({
  data,
  calculatorStructure,
}) => {
  return (
    <CalculatorParameters_v2020_B>
      {params_v2020_B => (
        <IsFormFilled
          data={data}
          calculatorStructure={calculatorStructure}
          onFalse={<IncompleteData />}
          onTrue={dataForResults => (
            <ResultsPanelView
              gdmRisk_v2020_B={gdmPredictedRisk_v2020(
                dataForResults,
                params_v2020_B
              )}
              progressCardData={data}
            />
          )}
        />
      )}
    </CalculatorParameters_v2020_B>
  )
}

export default ResultsPanel
